export default {
  facebook: require(`./facebook.png`).default,
  instagram: require(`./instagram.png`).default,
  linkedin: require(`./linkedin.png`).default,
  github: require(`./github.png`).default,
};
